import { useState } from 'react'
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Input,
  Label,
} from '@brent/core-ui/ui'
import { Loader2 } from 'lucide-react'

interface PublishDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onPublish: (opensAt: string, closesAt: string) => void
  isPending: boolean
}

export default function PublishDialog({
  open,
  onOpenChange,
  onPublish,
  isPending,
}: PublishDialogProps) {
  const [immediately, setImmediately] = useState(true)
  const [opensAt, setOpensAt] = useState('')
  const [closesAt, setClosesAt] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    const effectiveOpensAt = immediately
      ? new Date().toISOString()
      : new Date(opensAt).toISOString()
    const effectiveClosesAt = new Date(closesAt).toISOString()
    onPublish(effectiveOpensAt, effectiveClosesAt)
  }

  const isValid = closesAt && (immediately || opensAt)

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Publish Survey</DialogTitle>
          <DialogDescription>
            Set when the survey opens and closes for member responses.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="immediately"
                checked={immediately}
                onChange={(e) => setImmediately(e.target.checked)}
                className="h-4 w-4 rounded border-input"
              />
              <Label htmlFor="immediately">Open immediately</Label>
            </div>

            {!immediately && (
              <div className="space-y-2">
                <Label htmlFor="opensAt">Opens at</Label>
                <Input
                  id="opensAt"
                  type="datetime-local"
                  value={opensAt}
                  onChange={(e) => setOpensAt(e.target.value)}
                />
              </div>
            )}

            <div className="space-y-2">
              <Label htmlFor="closesAt">Closes at</Label>
              <Input
                id="closesAt"
                type="datetime-local"
                value={closesAt}
                onChange={(e) => setClosesAt(e.target.value)}
              />
            </div>
          </div>

          <Button type="submit" disabled={!isValid || isPending}>
            {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Publish Survey
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  )
}
